import React, {useEffect, useState} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import axios from 'axios'
import {TextSub2} from '../../components/TextSub2'
import {Button} from 'react-bootstrap'
import MainCategoryPlacesCard from '../../components/MainCategoryPlacesCard'
import Pagination from 'react-js-pagination'
import ImagePath from '../../../commons/ImagePath'
import {toast} from 'react-toastify'
import Modal2 from '../../components/Modal2'

export function MarketingPlaceCommentaryAdd() {
    const [modalVisible, setModalVisible] = useState(false)

    const [keyword, setKeyword] = useState('')
    const [sort, setSort] = useState('new')

    const [tempPlaces, setTempPlaces] = useState<any>('')

    const [mobileImage, setMobileImage] = useState<any>('')
    const [image, setImage] = useState<any>('')

    const [places, setPlaces] = useState<any>('')
    const [currentPage, setCurrentPage] = useState(0)
    const [perPage, setPerPage] = useState(0)
    const [total, setTotal] = useState(0)

    useEffect(() => {
        return () => {}
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const handlePageChange = (page: number) => {
        getPlaces(page)
    }

    const getPlaces = (page = 1) => {
        axios
            .post(`${process.env.REACT_APP_API2_URL}search/place`, {
                page,
                keyword,
                sort
            })
            .then(({data: {error, result}}) => {
                console.log(error)
                console.log(result)
                if (error !== '') {
                } else {
                    setPlaces(result.data)
                    setCurrentPage(result.current_page)
                    setPerPage(result.per_page)
                    setTotal(result.total)
                    window.scrollTo(0, 0)
                    // this.forceUpdate()
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const getCommentaryPlace = (place: any) => {
        axios
            .get(`${process.env.REACT_APP_API2_URL}am/marketing/commentary/place/${place.id}`)
            .then(({data: {error, result}}) => {
                console.log(error)
                console.log(result)
                if (error !== '') {
                    alert(error)
                } else {
                    addPlace(place)
                    setModalVisible(false)
                    // this.forceUpdate()
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const addImages = (image: any) => {
        console.log('add', image)
        setImage(image)
    }

    const addMobileImages = (image: any) => {
        console.log('add', image)
        setMobileImage(image)
    }

    const removeImages = (image: any) => {
        console.log('delete', image)
        setImage('')
    }

    const removeMobileImages = (image: any) => {
        console.log('delete', image)
        setMobileImage('')
    }

    const addPlace = (place: any) => {
        console.log('add', place)
        console.log('add', tempPlaces)
        const temps = [...tempPlaces]
        temps.splice(0, temps.length)
        temps.splice(0, 0, place)
        setTempPlaces(temps)
    }

    const removePlace = (place: any) => {
        if (window.confirm(`${place.id}. ${place.title} 장소를 삭제하시겠습니까?`)) {
            console.log('delete', place)
            setTempPlaces('')
        }
    }

    const handleItemFileInputMobile = (e: any) => {
        console.log(mobileImage.length)

        console.log(e)

        const file = e.target.files[0]
        axios.get(`${process.env.REACT_APP_API2_URL}upload/image`).then(({data: {error, result}}) => {
            if (error === '') {
                const {path, url} = result
                axios
                    .put(url, file, {
                        headers: {
                            'Content-Type': file?.type,
                        },
                    })
                    .then((response) => {
                        console.log(path)
                        axios
                            .post(`${process.env.REACT_APP_API2_URL}upload`, {
                                path,
                                type: 'image',
                            })
                            .then(({data: {error, result}}) => {
                                if (error === '') {
                                    // main_vue.completeImage(file, response.data.result)

                                    let imageId = result.id
                                    let imagePath = result.image_path

                                    console.log(imageId)
                                    console.log(imagePath)

                                    const temp = Object.assign({}, mobileImage)
                                    temp.imageId = imageId
                                    temp.imagePath = imagePath
                                    addMobileImages(temp)
                                } else {
                                    console.log(error)
                                    // main_vue.failImage(file)
                                }
                            })
                            .catch((error) => {
                                console.log(error)
                                // main_vue.failImage(file)
                            })
                    })
                    .catch((error) => {
                        console.log(error)
                        // main_vue.failImage(file)
                    })
            } else {
                // main_vue.failImage(file);
                alert('이미지 등록 실패')
            }
        })
    }

    const handleItemFileInput = (e: any) => {
        console.log(e)

        const file = e.target.files[0]
        axios.get(`${process.env.REACT_APP_API2_URL}upload/image`).then(({data: {error, result}}) => {
            if (error === '') {
                const {path, url} = result
                axios
                    .put(url, file, {
                        headers: {
                            'Content-Type': file?.type,
                        },
                    })
                    .then((response) => {
                        console.log(path)
                        axios
                            .post(`${process.env.REACT_APP_API2_URL}upload`, {
                                path,
                                type: 'image',
                            })
                            .then(({data: {error, result}}) => {
                                if (error === '') {
                                    // main_vue.completeImage(file, response.data.result)

                                    let imageId = result.id
                                    let imagePath = result.image_path

                                    console.log(imageId)
                                    console.log(imagePath)

                                    const temp = Object.assign({}, image)
                                    temp.imageId = imageId
                                    temp.imagePath = imagePath
                                    addImages(temp)
                                } else {
                                    console.log(error)
                                    // main_vue.failImage(file)
                                }
                            })
                            .catch((error) => {
                                console.log(error)
                                // main_vue.failImage(file)
                            })
                    })
                    .catch((error) => {
                        console.log(error)
                        // main_vue.failImage(file)
                    })
            } else {
                // main_vue.failImage(file)
            }
        })
    }

    const onSave = () => {
        console.log(tempPlaces)
        console.log(tempPlaces.length)
        console.log(image)
        console.log(mobileImage)

        if (mobileImage === '') {
            toast.error('필수 이미지 1장을 등록해주세요.')
            return false
        }
        if (image === '') {
            toast.error('필수 이미지 1장을 등록해주세요.')
            return false
        }

        let placeId = 0
        if (tempPlaces.length !== 0) {
            placeId = tempPlaces[0].id
        }

        axios
            .post(`${process.env.REACT_APP_API2_URL}am/marketing/commentary`, {
                image: image,
                mobileImage: mobileImage,
                placeId: placeId,
            })
            .then(({data: {error, result}}) => {
                console.log(error)
                console.log(result)
                if (error !== '') {
                    alert(error)
                } else {
                    alert('등록되었습니다.')
                    //window.location.href = `/marketing/interview`
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }

    return (
        <>
            <PageTitle breadcrumbs={[]}>장소 코멘터리</PageTitle>

            <div style={{padding: 20, borderRadius: 20, backgroundColor: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <div style={{padding: 20, borderRadius: 20, backgroundColor: 'white', width: '100%'}}>
                    <div className='card card-custom card-stretch shadow mb-5'>
                        <div className='card-body'>
                            <TextSub2 title={'장소 연결하기'} subTitle={''} />
                            {(tempPlaces === null || tempPlaces === '') && (
                                <span className='pr-4'>
                                    <Button
                                        variant='success'
                                        onClick={() => {
                                            setModalVisible(true)
                                        }}
                                    >
                                        장소 추가
                                    </Button>
                                </span>
                            )}

                            <div style={{marginTop: 40, display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
                                {tempPlaces !== null &&
                                    tempPlaces !== '' &&
                                    tempPlaces.map((item: any, index: number) => {
                                        return <MainCategoryPlacesCard place={item} key={index} removePlace={removePlace} />
                                    })}
                            </div>

                            <div className='separator my-10' />
                            <h2>이미지 추가</h2>
                            <div className='row'>
                                <div className='col-6'>
                                    <TextSub2 title={'MOBILE'} subTitle={''} />
                                    {mobileImage === '' && (
                                        <>
                                            <label
                                                className='input-file-button'
                                                htmlFor='input-file'
                                                style={{
                                                    width: '169px',
                                                    height: '52px',
                                                    paddingTop: '16px',
                                                    paddingLeft: '34px',
                                                    fontSize: '16px',
                                                    lineHeight: '22px',
                                                    backgroundColor: '#3C82FA',
                                                    borderRadius: '8px',
                                                    color: 'white',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                이미지 추가하기
                                            </label>
                                            <input
                                                type='file'
                                                id='input-file'
                                                style={{display: 'none'}}
                                                onChange={(e) => {
                                                    handleItemFileInputMobile(e)
                                                }}
                                            />
                                        </>
                                    )}
                                    {mobileImage !== null && mobileImage !== '' && (
                                        <>
                                            <img src={ImagePath.getS3(mobileImage.imagePath)} alt='picture' style={{width: '100%', paddingRight: 12, paddingBottom: 12}} />
                                            <i
                                                className='bi bi-x-lg'
                                                style={{
                                                    marginTop: 5,
                                                    marginLeft: -43,
                                                    position: 'absolute',
                                                    color: 'white',
                                                    cursor: 'pointer',
                                                    width: 27,
                                                    height: 25,
                                                    backgroundColor: 'red',
                                                    textAlign: 'center',
                                                    lineHeight: '24px',
                                                    fontSize: 16,
                                                }}
                                                onClick={() => {
                                                    removeMobileImages(mobileImage)
                                                }}
                                            ></i>
                                        </>
                                    )}
                                </div>
                                <div className='col-6'>
                                    <TextSub2 title={'PC'} subTitle={''} />
                                    {image === '' && (
                                        <>
                                            <label
                                                className='input-file-button'
                                                htmlFor='input-file'
                                                style={{
                                                    width: '169px',
                                                    height: '52px',
                                                    paddingTop: '16px',
                                                    paddingLeft: '34px',
                                                    fontSize: '16px',
                                                    lineHeight: '22px',
                                                    backgroundColor: '#3C82FA',
                                                    borderRadius: '8px',
                                                    color: 'white',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                이미지 추가하기
                                            </label>
                                            <input
                                                type='file'
                                                id='input-file'
                                                style={{display: 'none'}}
                                                onChange={(e) => {
                                                    handleItemFileInput(e)
                                                }}
                                            />
                                        </>
                                    )}

                                    {image != null && image !== '' && (
                                        <>
                                            <img src={ImagePath.getS3(image.imagePath)} alt='picture' style={{width: '100%', paddingRight: 12, paddingBottom: 12}} />
                                            <i
                                                className='bi bi-x-lg'
                                                style={{
                                                    marginTop: 5,
                                                    marginLeft: -43,
                                                    position: 'absolute',
                                                    color: 'white',
                                                    cursor: 'pointer',
                                                    width: 27,
                                                    height: 25,
                                                    backgroundColor: 'red',
                                                    textAlign: 'center',
                                                    lineHeight: '24px',
                                                    fontSize: 16,
                                                }}
                                                onClick={() => {
                                                    removeImages(image)
                                                }}
                                            ></i>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{marginTop: 40, textAlign: 'center'}}>
                        <Button
                            variant='primary'
                            onClick={() => {
                                onSave()
                            }}
                        >
                            저장하기
                        </Button>
                    </div>
                </div>
            </div>

            {modalVisible && (
                <Modal2
                    visible={modalVisible}
                    closable={true}
                    maskClosable={true}
                    onClose={() => {
                        setModalVisible(false)
                    }}
                    className={''}
                >
                    <div style={{marginTop: 10, marginBottom: 15, display: 'flex', flexDirection: 'row', alignItems: 'center'}} className='card card-custom card-stretch shadow mb-5'>
                        <input
                            type='text'
                            className='form-control'
                            placeholder='장소 검색어'
                            style={{flex: 1, width: 10}}
                            onChange={(e) => {
                                setKeyword(e.target.value.toLowerCase().trim())
                            }}
                        />
                        <label
                            onClick={() => {
                                getPlaces()
                            }}
                            style={{width: 100}}
                            className='btn btn-dark'
                        >
                            검색
                        </label>
                    </div>
                    <div className={'row'} style={{height: '72vh', overflowY: 'auto'}}>
                        {places !== null &&
                            places !== '' &&
                            places.map((place: any, index: number) => {
                                return (
                                    <div className='col-lg-3' key={'place_' + index.toString()}>
                                        <div className='card card-custom card-stretch shadow mb-5'>
                                            <div className='card-header'>
                                                <h1 className='card-title'>
                                                    {place.id}. {place.title}
                                                </h1>
                                            </div>
                                            <div className='card-body'>
                                                <img className='rounded' src={ImagePath.get(place.main_image_path, "166.88x120")} style={{height: 120, width: '100%'}} alt='' />
                                                <h3>{place.price.toLocaleString('en')}</h3>
                                            </div>
                                            <div className='card-footer'>
                                                <label
                                                    onClick={() => {
                                                        if (window.confirm(`${place.id}. ${place.title} 장소를 추가하시겠습니까?`)) {
                                                            getCommentaryPlace(place)
                                                        }
                                                    }}
                                                    className='btn btn-primary'
                                                >
                                                    추가
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        {places !== null && places !== '' && (
                            <Pagination
                                activePage={currentPage}
                                itemsCountPerPage={perPage}
                                totalItemsCount={total}
                                pageRangeDisplayed={10}
                                prevPageText={'‹'}
                                nextPageText={'›'}
                                onChange={handlePageChange}
                            />
                        )}
                    </div>
                </Modal2>
            )}
        </>
    )
}
